var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticClass: "title" },
        [
          _c("v-icon", { staticClass: "mr-2" }, [_vm._v("link")]),
          _vm._v(" "),
          _c("div", [_vm._v("Services Refresh Tokens")]),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-card-text", [
        _c("div", [
          _vm._v(
            "\n      Service Refresh Tokens are used by service registry to acquire access token to access the system.\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("v-autocomplete", {
              staticClass: "rounded",
              attrs: {
                solo: "",
                items: _vm.tenants,
                label:
                  _vm.tenants.length > 0 ? "Select a tenant" : "No tenants",
                clearable: "",
                "single-line": "",
                "item-text": "RoleName",
                "item-value": "Id",
                "return-object": "",
                "persistent-hint": "",
              },
              model: {
                value: _vm.selectedTenant,
                callback: function ($$v) {
                  _vm.selectedTenant = $$v
                },
                expression: "selectedTenant",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.selectedTenant && _vm.checkingResult.Valid
          ? _c(
              "div",
              [
                _c("v-icon", {
                  staticClass: "mr-1",
                  attrs: { color: "primary" },
                  domProps: { innerHTML: _vm._s("done") },
                }),
                _vm._v(
                  " Tenant " +
                    _vm._s(_vm.selectedTenant.RoleName) +
                    " contains valid service refresh token already.\n      "
                ),
                _c(
                  "v-btn",
                  {
                    nativeOn: {
                      click: function ($event) {
                        return _vm.generateServiceRefreshToken(true)
                      },
                    },
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [_vm._v("refresh")]),
                    _vm._v("\n        Regenerate service refresh token"),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.selectedTenant && !_vm.checkingResult.Valid
          ? _c(
              "div",
              [
                _c("v-icon", {
                  staticClass: "mr-1",
                  attrs: { color: "error" },
                  domProps: { innerHTML: _vm._s("clear") },
                }),
                _vm._v(
                  " Tenant " +
                    _vm._s(_vm.selectedTenant.RoleName) +
                    " does not contain valid service refresh token yet.\n      "
                ),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "warning", loading: _vm.loading },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.generateServiceRefreshToken(false)
                      },
                    },
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [_vm._v("add")]),
                    _vm._v("\n        Generate service refresh token"),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }